// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"O2-z"};